import { useMutation } from '@tanstack/react-query'

import { apiClient } from '@src/services/http-common'
import { ClassificationReportRequestDto, ClassificationReportResponse } from '@src/types/classificationReport'
import { DocumentPage } from '@src/types/documentPage'

export const useClassificationReport = () => {
  return useMutation({
    mutationFn: async (request: ClassificationReportRequestDto) => {
      const response = await apiClient.post<ClassificationReportResponse>('/report/classification', request)
      return response.data
    },
  })
}

export const useClassificationPageDetails = () => {
  return useMutation({
    mutationFn: async (pageIds: string[]) => {
      const response = await apiClient.post<DocumentPage[]>('/report/classification/pages', { pageIds })
      return response.data
    },
  })
}
